export interface Instructor {
  id: number;
  name: string;
  title: string;
  belt: string;
  bio: string;
  image: string;
  social: {
    email?: string;
    facebook?: string;
    instagram?: string;
  };
  backgroundImage: string;
}

export interface Assistant {
  id: number;
  name: string;
  image: string;
  rank: string;
}

export const instructors: Instructor[] = [
  {
    id: 1,
    name: "Snr. Master Juliet Williams",
    title: "Master Juliet",
    belt: "7th Dan",
    bio: "I have been training in martial arts for over 30 years. For all but 3 of those years, I have had the privilege of teaching martial arts. I continue to do so today out of a deep desire to give back to the art and to my students.\n\nAs a Senior Master, I believe it is my responsibility to pass on not only my own knowledge but the invaluable teachings of Supreme Grand Master as well. I have always felt that martial arts are immensely beneficial for anyone, regardless of age or background.\n\nI am passionate about encouraging others to explore martial arts. I especially appreciate Taekwondo for its ability to improve both physical strength and mental clarity. I believe that a skilled instructor is key in helping each person find the martial art that best suits their needs. With the right guidance and mentorship, martial arts can be a powerful catalyst for personal growth and transformation.\n\nThe best feeling as an instructor is seeing a student grow in confidence or master a technique they never thought they could do. Inspiring confidence in students in all ages, from 4 years to 64 years, is the best thing you can do as it leaves the school with them and helps them in their life outside the Martial Arts.\n\nOne of my other proud achievements is guiding 3 students through to Master grade 5th Dan: Master Trey Drysdale, Master Samuel Charlton and Master Damian Wood.",
    image: "/images/instructors/juliet_new.jpeg",
    social: {
      email: "juliet@omac-uk.com",
      facebook: "facebook.com/juliet.williams",
      instagram: "instagram.com/master_juliet"
    },
    backgroundImage: "juliet_sepia.png"
  },
  {
    id: 2,
    name: "Master Sam Charlton",
    title: "Master Charlton",
    belt: "6th Dan",
    bio: "Over the past 25 years, I have been deeply committed to the study and practice of Taekwondo—a journey that began during a period when I felt lost and lacking direction in life. I sought a way to channel my energy and develop focus, and Taekwondo provided that transformative outlet.\n\nEmbracing the art not only revolutionised my physical fitness but also instilled a sense of discipline, resilience, and purpose that has enriched every aspect of my life. Through rigorous training and a commitment to its philosophy, I discovered a reservoir of strength and determination that continues to inspire me every day.\n\nFor the past 23 and a half years, I have proudly served as a Taekwondo instructor. Teaching has been an incredibly rewarding experience, allowing me to guide others on their own journeys toward self-improvement and martial arts mastery.\n\nWitnessing my student's growth in skill, confidence, and character reinforces my belief in the transformative power of Taekwondo and fuels my passion for sharing its benefits with the next generation.",
    image: "/images/instructors/master_charlton_new.jpeg",
    social: {
      email: "sam@omac-uk.com",
      facebook: "facebook.com/sam.charlton",
      instagram: "instagram.com/master_charlton"
    },
    backgroundImage: "sam_480.png"
  },
  {
    id: 3,
    name: "Snr. Instructor Stuart Williams",
    title: "Mr Stuart",
    belt: "4th Dan",
    bio: "I have been involved in martial arts since I was 21 and at 55, I still find immense value in its teachings. Before I began practicing Taekwondo, I held a Black Belt in Chinese Boxing, while I was still training in Brazilian Jiu-Jitsu, Supreme Grandmaster Choi gave me a Taekwondo uniform and told me that I had to promise to start training. Approximately a year later, I began my journey in Taekwondo, having also been encouraged by Master Juliet to explore this art form.\n\nMaster Juliet encouraged me to start Taekwondo at white belt and work my way up through the ranks alongside the other students, this earned me their respect and taught me humility.\n\nWhat I enjoy most about Taekwondo is the strong sense of club spirit and the camaraderie that develops during training. Not only do we benefit from the physical exercise, but we also share a mutual support that fosters personal growth.\n\nEven more fulfilling is the opportunity to pass on my knowledge to my students. Witnessing their progress—from beginners to skilled practitioners—truly inspires me. It is especially rewarding to see some of the younger students excel and eventually achieve their Black Belt, a milestone that reflects both their dedication and the enduring spirit of Taekwondo.",
    image: "/images/instructors/mister_stuart_new.jpeg",
    social: {
      email: "stuart@omac-uk.com",
      facebook: "facebook.com/stuart.williams"
    },
    backgroundImage: "stu_sepia.png"
  },
  {
    id: 4,
    name: "Snr. Instructor Filomena Pagnozzi",
    title: "Miss Fil",
    belt: "4th Dan",
    bio: "I've been training in Taekwondo for 24 years. Over the years, both of my children have trained as well, and one has even gone on to achieve their black belt.\n\nI originally started training for self-defence, but I quickly fell in love with the art, the discipline, and the journey of continuous self-improvement. Taekwondo has given me confidence, resilience, and a strong sense of community.\n\nTeaching has been an incredibly rewarding experience for me. I love being able to share my knowledge and experiences with others, helping students grow in both skill and confidence.\n\nThere's something special about seeing someone progress, overcome challenges, and find the same joy in Taekwondo that I did. Passing on my passion for martial arts and watching students develop their own is one of the most fulfilling parts of my journey.",
    image: "/images/instructors/fil.jpeg",
    social: {
      email: "filomena@omac-uk.com",
      facebook: "facebook.com/filomena.pagnozzi",
      instagram: "instagram.com/fil_tkd"
    },
    backgroundImage: "fil_sepia.png"
  },
  {
    id: 5,
    name: "Snr. Instructor Louis Harper",
    title: "Mr Louis",
    belt: "4th Dan",
    bio: "I have dedicated 11 and a half years to practicing Taekwondo. My journey began with a desire to challenge myself and to learn new techniques.\n\nI love Taekwondo because it challenges me to learn new skills and push my limits in ways that foster both physical and mental growth. The art instils discipline and perseverance and enriches my personal and professional life.\n\nI enjoy teaching Taekwondo because it gives me the chance to share these valuable lessons with others. It brings me great satisfaction to guide my students on their journey toward becoming the best version of themselves in martial arts and in life.",
    image: "/images/instructors/louis_new_two.jpeg",
    social: {
      email: "louis@omac-uk.com",
      instagram: "instagram.com/louis_tkd"
    },
    backgroundImage: "louis_sepia.png"
  },
  {
    id: 6,
    name: "Instructor Loki Sergent",
    title: "Mr Loki",
    belt: "3rd Dan",
    bio: "I began training in Taekwondo at OMAC-UK in 2017, when I was seven years old. During my time training, I've learnt so much not only about Taekwondo as a martial art, but also about the rich history of our school, which began with our Supreme Grandmaster Choi.\n\nTeaching at OMAC-UK is amazing, as I get to see our students progress and move up through the ranks, just as we all did, and become part of that rich history.\n\nBeing part of OMAC-UK is an amazing feeling. The support, training and teamwork we experience help us develop the skills we need to secure our future as both martial artists and good citizens.",
    image: "/images/instructors/loki.jpeg",
    social: {
      email: "loki@omac-uk.com",
      instagram: "instagram.com/kasey_tkd"
    },
    backgroundImage: "loki_sepia.png"
  },
  // {
  //   id: 6,
  //   name: "Instructor Kacey Joszko",
  //   title: "Miss Kacey",
  //   belt: "3rd Dan",
  //   bio: "I have been practicing Taekwondo at OMAC-UK for the past 10 years, and through patience and dedication to the art, I have earned a third-degree Black belt.\n\nI pursue Taekwondo not only as a method of self-defence but also to maintain and improve my fitness. This journey has significantly enhanced my self-confidence and overall well-being.\n\nFor the past three years, I have had the privilege of teaching Taekwondo.\n\nIt is incredibly rewarding to witness my students grow, as they develop their skills and fully embrace the discipline, respect, and spirit that define Taekwondo.",
  //   image: "/images/instructors/kasey.jpeg",
  //   social: {
  //     email: "kasey@omac-uk.com",
  //     instagram: "instagram.com/kasey_tkd"
  //   },
  //   backgroundImage: "kasey_sepia.png"
  // },
  {
    id: 7,
    name: "Instructor Nathan Everington",
    title: "Mr Nathan",
    belt: "3rd Dan",
    bio: "I began training at OMAC-UK in 2014, starting out as a hobby outside of school. Over the past ten years, I have gained so much knowledge and experience, and taekwondo has become a huge influence in my life.\n\nFrom the very beginning, I fell in love with training, not only as physical exercise but as a way to develop mind, body, spirit, and emotion together as a martial artist.\n\nI want to teach because, as I came up through the ranks, I was inspired by Supreme Grandmaster Choi, Master Andy, Master Juliet, and many others. I hope to pass on the knowledge and inspiration they gave me to future students.\n\nBeing part of OMAC has been a welcoming and supportive journey, and it continues to shape me both as a martial artist and as a person.",
    image: "/images/instructors/nathan_new_raw.jpeg",
    social: {
      email: "nathan@omac-uk.com",
      instagram: "instagram.com/nathan_tkd"
    },
    backgroundImage: "nathan_break_new_new.png"
  },
  {
    id: 8,
    name: "Instructor Ian Walker",
    title: "Mr Ian",
    belt: "3rd Dan",
    bio: "I have been training at OMAC for almost seven years. I started training because I recognised that I needed to improve my physical fitness and wanted to engage in a sport that challenges both body and mind.\n\nThrough my training, I have seen significant improvements in my physical fitness, and I have developed strength, endurance, and flexibility that I never thought possible. The discipline I gain from training translates into all areas of my life. It helps me remain focused and overcome obstacles with determination.\n\nI derive great satisfaction from helping others learn. Often teaching pushes me outside my comfort zone but I welcome that challenge. This experience has deepened my passion for the sport and helped me grow both as an athlete and as a mentor.",
    image: "/images/instructors/ian.jpeg",
    social: {
      email: "ian@omac-uk.com",
      facebook: "facebook.com/ian.walker"
    },
    backgroundImage: "ian_sepia.png"
  },
  {
    id: 9,
    name: "Instructor Rebecca Whittingham",
    title: "Miss Becs",
    belt: "3rd Dan",
    bio: "My introduction to martial arts was as a Taekwondo Mum when my son started the Lil\' Dragons programme in 2010. I then began training at the age of 45 in 2018, having already had a taster of kickboxing through OMAC-UK.\n\nPracticing martial arts was a great way to spend time with my teenager and stay connected through a shared interest. I've always enjoyed keeping fit, but I needed a challenge—something new, something for myself—to reset, push beyond my comfort zone, and build confidence. Taekwondo ticked all those boxes and more.\n\nI'm proud to train with and teach our lively community of inspiring students and families. I firmly believe martial arts is for all ages and abilities; it brings balance and focus to modern, busy lives, providing space for personal well-being, as well as physical and mental growth.\n\nTraining and teaching are incredibly rewarding and fulfilling. Through teaching, I learn with humility each day how to adapt, practice, and guide. It is a pleasure to support and witness students as they empower themselves—mastering techniques, improving self-esteem, having fun, and taking ownership of their training to strive beyond their goals.",
    image: "/images/instructors/becs_smile.jpeg",
    social: {
      email: "rebecca@omac-uk.com",
      facebook: "facebook.com/rebecca.whittingham",
      instagram: "instagram.com/becs_tkd"
    },
    backgroundImage: "becs_sepia.png"
  },
  {
    id: 10,
    name: "Associate Instructor Isabelle Rodrigues-Lima",
    title: "Miss Izzy",
    belt: "2nd Dan",
    bio: "I have been practicing Taekwondo for over three years, and it has become an essential part of my life.\n\nTaekwondo helps me build and maintain a strong, healthy physique through regular practice. It instils discipline and nurtures self-confidence that enriches my everyday life. My growing self-confidence enables me to face challenges with resilience and focus.\n\nIn addition to my personal training, I find great fulfilment in teaching Taekwondo. Sharing my passion with others and helping them improve both physically and mentally is incredibly rewarding. I love guiding my students as they discover their potential and embrace the transformative power of this martial art.",
    image: "/images/instructors/izzy.jpeg",
    social: {
      email: "isabelle@omac-uk.com",
      instagram: "instagram.com/izzy_tkd"
    },
    backgroundImage: "izzy_sepia.png"
  }
];

export const assistants: Assistant[] = [

  { id: 11, name: "Tate", image: "/images/assistants/tate.jpeg", rank: 'Black Belt (3rd Dan)' },
  { id: 12, name: "Obi", image: "/images/assistants/obi.jpeg", rank: 'Black Belt (2nd Dan)' },
  { id: 13, name: "Franklin", image: "/images/assistants/frank.jpeg", rank: 'Black Belt (1st Dan)' },
  { id: 14, name: "Noah", image: "/images/assistants/noah.jpeg", rank: 'Black Belt (1st Dan)' },
  // { id: 15, name: "Bowie", image: "/images/assistants/bowie.jpeg", rank: 'Black Belt (1st Dan)' },
  { id: 16, name: "Isabelle", image: "/images/assistants/isabelle.jpeg", rank: 'Black Belt (1st Dan)' },
  { id: 18, name: "Stu", image: "/images/assistants/stu.jpeg", rank: 'Black Belt (1st Dan)' },
  { id: 17, name: "Abbey", image: "/images/assistants/abbey.jpeg", rank: 'Black/White (1st Kup)' },
  { id: 19, name: "Linda", image: "/images/assistants/linda.jpeg", rank: 'Black/White (1st Kup)' }
];
